import { useNavigate, useLocation } from 'react-router-dom';
import './ShopBottomNav.css';

const ITEMS = [
  { icon: '🏠', label: 'Dashboard', path: '/shop/dashboard' },
  { icon: '🏷️', label: 'Deals',     path: '/shop/deals' },
  { icon: '📷', label: 'Scan',      path: '/shop/scan' },
  { icon: '📊', label: 'Stats',     path: '/shop/stats' },
  { icon: '🪙', label: 'Tokens',    path: '/shop/tokens' },
  { icon: '🏪', label: 'Profiel',   path: '/shop/profile' },
];

export default function ShopBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <nav className="shop-nav">
      {ITEMS.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <button
            key={item.path}
            className={`shop-nav__item${isActive ? ' shop-nav__item--active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span className="shop-nav__icon">{item.icon}</span>
            <span className="shop-nav__label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
